import { IconButton, styled } from "@mui/material";
import ArrowLeftIcon from "../../../icons/Components/ArrowLeft";

interface IProps {
  text: string;
  back?: () => void;
}

const AuthMoveBack = (props: IProps) => {
  const { text, back } = props;

  return (
    <Container>
      { back && (
        <IconButton
          onClick={back}
          sx={{
            background: "rgba(216, 223, 236, 0.3)",
            color: "white",
            width: "24px",
            height: "24px",
            minWidth: "unset",
            "& svg": {
              color: "black"
            },
            "&:hover": {
              background: "rgba(216, 223, 236, 0.3)"
            }
          }}
        >
          <ArrowLeftIcon/>
        </IconButton>
      )}
      <p>{text}</p>
    </Container>
  );
};

export default AuthMoveBack;

const Container = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  "& p": {
    fontSize: "20px",
    textTransform: "capitalize !important"
  }
});
